// extracted by mini-css-extract-plugin
export default {"footerBtns":"CancelLesson_footerBtns__wUZwG","mb16":"CancelLesson_mb16__VsBJa","disclaimerSection":"CancelLesson_disclaimerSection__FGKHB"};